


























import axios from 'axios'
import { Component, Vue } from 'vue-property-decorator'

import { putSuoritusarviointi } from '@/api/erikoistuva'
import ArviointiForm from '@/forms/arviointi-form.vue'
import { Suoritusarviointi } from '@/types'
import { formatSaveError } from '@/utils/errorMessage'
import { toastFail, toastSuccess } from '@/utils/toast'

@Component({
  components: {
    ArviointiForm
  }
})
export default class Itsearviointi extends Vue {
  value: Suoritusarviointi | null = null
  items = [
    {
      text: this.$t('etusivu'),
      to: { name: 'etusivu' }
    },
    {
      text: this.$t('arvioinnit'),
      to: { name: 'arvioinnit' }
    },
    {
      text: this.$t('tee-itsearviointi'),
      active: true
    }
  ]

  async mounted() {
    if (this.$route && this.$route.params && this.$route.params.arviointiId) {
      try {
        this.value = (
          await axios.get(
            `erikoistuva-laakari/suoritusarvioinnit/${this.$route.params.arviointiId}`
          )
        ).data
        if (this.value != null && this.value.lukittu) {
          toastFail(this, this.$t('suoritusarviointi-on-lukittu-itsearviointi-muokkaus'))
          this.$emit('skipRouteExitConfirm', true)
          this.$router.push({
            name: 'arviointi',
            params: { arviointiId: this.$route.params.arviointiId }
          })
        }
      } catch {
        toastFail(this, this.$t('arvioinnin-hakeminen-epaonnistui'))
        this.$emit('skipRouteExitConfirm', true)
        this.$router.replace({ name: 'arvioinnit' })
      }
    }
  }

  async onSubmit(
    value: {
      suoritusarviointi: Suoritusarviointi
      addedFiles: File[]
      deletedAsiakirjaIds: number[]
    },
    params: { saving: boolean }
  ) {
    params.saving = true
    try {
      const formData = new FormData()
      formData.append('suoritusarviointiJson', JSON.stringify(value.suoritusarviointi))
      value.addedFiles.forEach((file: File) => formData.append('arviointiFiles', file, file.name))
      formData.append('deletedAsiakirjaIdsJson', JSON.stringify(value.deletedAsiakirjaIds))

      await putSuoritusarviointi(formData)
      toastSuccess(this, this.$t('itsearvioinnin-tallentaminen-onnistui'))
      this.$emit('skipRouteExitConfirm', true)
      this.$router.push({
        name: 'arviointi',
        params: { arviointiId: this.$route.params.arviointiId }
      })
    } catch (err) {
      toastFail(
        this,
        formatSaveError(this, err, this.$t('itsearvioinnin-tallentaminen-epaonnistui'))
      )
    }
    params.saving = false
  }

  skipRouteExitConfirm(value: boolean) {
    this.$emit('skipRouteExitConfirm', value)
  }
}
